// const baseUrl = 'http://10.0.0.23:8081'
// const baseUrl = 'http://192.168.110.19:8081'
// const baseUrl = 'http://47.97.195.120:9001'
// const baseUrl = 'http://47.94.227.40:9001'  //测试环境
// const baseUrl = 'https://wmzh.life-oasis.com/api';  // 生产环境
// const baseUrl = 'https://yxzh.life-oasis.com/apis'; // 老生产环境
const baseUrl = process.env.VUE_APP_BASE_API || 'http://192.168.21.101:8080';
export default baseUrl;